import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import styled from 'styled-components';
import { z } from 'zod';

import Layout from '~/pages/_layout.page';
import { media } from '~/utils';

import { Main } from './main';
import { Side } from './side';

type FormT = {
  company: string;
  department: string;
  name: string;
  post: string;
  email: string;
  how: string;
  background: string;
  checked: boolean;
};

export const Template = () => {
  const [submitted, setSubmitted] = useState<boolean>(false);

  const form = useForm<FormT>({
    defaultValues: {
      company: '',
      department: '',
      name: '',
      post: '',
      email: '',
      how: '',
      background: '',
      checked: false,
    },
    resolver: zodResolver(
      z.object({
        company: z.string().min(1),
        department: z.string().min(1),
        name: z.string().min(1),
        post: z.string(),
        email: z.string().min(1),
        how: z.string().min(1),
        background: z.string(),
        checked: z.literal(true),
      }),
    ),
  });

  const onSubmit: SubmitHandler<FormT> = async (data) => {
    const res = await fetch('/api/survey', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (res.status === 200) {
      setSubmitted(true);
    } else {
      alert(
        'お問い合わせでエラーが発生しました。お手数ですが、「contact@ichicommons.com」までお問い合わせください。',
      );
    }
  };

  return (
    <Layout pageTitle='アンケート'>
      <StyledWrapper>
        <Main submitted={submitted} />
        <Side form={form} submitted={submitted} onSubmit={onSubmit} />
      </StyledWrapper>
    </Layout>
  );
};

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  ${media.mid`
    flex-direction: column;
  `}
`;
